import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "../lib/data";

export const Footer = () => (
  <footer className="border-t border-white/5 bg-[#0C0E0D]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 py-20 grid gap-14 md:grid-cols-3">
      <div>
        <Logo />
        <p className="mt-6 text-sm text-zinc-500 leading-relaxed max-w-xs">
          A friendly, family-run team for home improvements and property maintenance — domestic and commercial, big jobs and small.
        </p>
      </div>
      <div>
        <h3 className="font-mono-tech text-xs tracking-[0.25em] text-lime-400 uppercase mb-6">Explore</h3>
        <div className="flex flex-col gap-3 text-sm">
          <Link to="/" className="text-zinc-400 hover:text-lime-300 transition-colors duration-300 w-fit" data-testid="footer-link-home">Home</Link>
          <Link to="/services" className="text-zinc-400 hover:text-lime-300 transition-colors duration-300 w-fit" data-testid="footer-link-services">Services</Link>
          <Link to="/about" className="text-zinc-400 hover:text-lime-300 transition-colors duration-300 w-fit" data-testid="footer-link-about">About Us &amp; Booking</Link>
          <Link to="/faq" className="text-zinc-400 hover:text-lime-300 transition-colors duration-300 w-fit" data-testid="footer-link-faq">FAQ</Link>
        </div>
      </div>
      <div>
        <h3 className="font-mono-tech text-xs tracking-[0.25em] text-lime-400 uppercase mb-6">Contact</h3>
        <div className="flex flex-col gap-4 text-sm text-zinc-400">
          {CONTACT.people.map((p) => (
            <a
              key={p.name}
              href={`tel:${p.phone.replace(/\s/g, "")}`}
              className="flex items-center gap-3 hover:text-lime-300 transition-colors duration-300 w-fit"
              data-testid={`footer-phone-${p.name.toLowerCase()}`}
            >
              <Phone size={15} className="text-purple-400" /> {p.name} — {p.phone}
            </a>
          ))}
          <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-lime-300 transition-colors duration-300 w-fit" data-testid="footer-email">
            <Mail size={15} className="text-purple-400" /> {CONTACT.email}
          </a>
          <span className="flex items-center gap-3" data-testid="footer-area">
            <MapPin size={15} className="text-purple-400" /> {CONTACT.area}
          </span>
          <a
            href="https://www.facebook.com/HisHersHomeImprovement/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 hover:text-lime-300 transition-colors duration-300 w-fit"
            data-testid="footer-facebook"
          >
            <Facebook size={15} className="text-purple-400" /> Follow us on Facebook
          </a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/5 py-6 text-center text-xs text-zinc-600">
      © {new Date().getFullYear()} His &amp; Hers Home Improvements and Property Maintenance. All rights reserved.
    </div>
  </footer>
);
